import { init } from '@sentry/nextjs'
import { denyUrls, ignoreErrors } from 'sentry-ignores'
import packageInfo from './package.json'

init({
  release: packageInfo.version,
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  denyUrls,
  ignoreErrors: [
    ...ignoreErrors,
    // Next.js hydration errors
    'Text content does not match server-rendered HTML.',
    'Hydration failed because the initial UI does not match what was rendered on the server.',
    'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
    // Network errors
    'A network error occurred.'
  ]
})
